module.exports = new __parcel__URL__("fluffy.b67f5aa1.jpeg").toString();